import { render, staticRenderFns } from "./OctSalonSettingForm.vue?vue&type=template&id=0a301ac7&"
import script from "./OctSalonSettingForm.vue?vue&type=script&lang=js&"
export * from "./OctSalonSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports